// extracted by css-extract-rspack-plugin
export default {"count":"QToggle_count_B8mCC"};